<template>
    <div>
        <div class="flex items-center justify-between">
            <breadcrumbs>ActivityLog</breadcrumbs>
        </div>

        <div class="flex justify-between items-center">
            <h1 class="text-5xl text-teal-800">ActivityLog</h1>
        </div>

        <div class="flex justify-between items-center mb-5">
            <div class="flex flex-col">
                <!-- <search-filter v-model="form.search" class="w-full max-w-sm mr-4" @reset="reset" @input="submitSearch">
                    <label class="block text-grey-darkest">Subject Type:</label>
                    <select v-model="form.subject" class="mt-1 w-full form-select" @change="reloadData">
                        <option :value="null" />
                        <option v-for="(name, slug) in categories" :key="slug" :value="slug">{{ name }}</option>
                    </select>
                </search-filter> -->

                <active-filters :filters="filters" @remove-filter="removeFilter" />
            </div>

            <num-results name="activities"
                         :from="activities.from"
                         :to="activities.to"
                         :total="activities.total"
            />

            <input type="hidden" v-model="form.orderBy" />
            <input type="hidden" v-model="form.sortOrder" />
        </div>

        <table v-if="activities.data.length" class="w-full whitespace-no-wrap bg-white rounded">
            <tr class="text-teal-800 font-bold">
                <td class="px-3 py-3"><i class="fal fa-calendar-plus mr-1"></i>Created</td>
                <td class="px-3 py-3">Description</td>
                <td class="px-3 py-3">Subject</td>
                <td class="px-3 py-3">Subject ID</td>
                <td class="px-3 py-3">Causer</td>
                <td class="px-3 py-3">Properties</td>
            </tr>

            <tr
                v-for="(activity, index) in activities.data"
                :key="activities.id"
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="{ 'bg-teal-100': !(index % 2), 'text-gray-500': activity.deleted_at }"
            >
                <td class="border-t px-3 py-4">
                    <!-- <inertia-link class="py-4 flex items-center" :href="route('admin.activitylog.show', activity.id)" tabindex="-1"> -->
                    {{ moment(activity.created_at).format("DD-MM-YYYY HH:mm:ss") }}
                    <!-- </inertia-link> -->
                </td>

                <td class="border-t px-3 py-4">
                    <!-- <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.activitylog.show', activity.id)"> -->
                    {{ activity.description | truncate(50) }}
                    <!-- </inertia-link> -->
                </td>

                <td class="border-t px-3">
                    <inertia-link
                        v-if="activity.subject_type === 'App\\JobOffer'"
                        class="py-4 flex items-center focus:text-teal-800 truncate"
                        :href="route('admin.joboffers.show', activity.subject_id)"
                    >
                        {{ activity.subject_type }}
                    </inertia-link>
                    <inertia-link
                        v-else-if="activity.subject_type === 'App\\Tag'"
                        class="py-4 flex items-center focus:text-teal-800 truncate"
                        :href="route('admin.tags.show', activity.subject_id)"
                    >
                        {{ activity.subject_type }}
                    </inertia-link>
                    <span v-else>
                        {{ activity.subject_type }}
                    </span>
                </td>

                <td class="border-t px-3 py-4">
                    <!-- <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.activitylog.show', activity.id)"> -->
                    {{ activity.subject_id }}
                    <!-- </inertia-link> -->
                </td>

                <td class="border-t px-3 py-4">
                    <!-- <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.activitylog.show', activity.id)"> -->

                    <!-- {{ activity.causer_type }} -->
                    <span v-if="activity.causer && activity.causer_type === 'App\\AdminUser'">{{ activity.causer.first_name }}</span>
                    <!-- </inertia-link> -->
                </td>

                <!-- <td class="border-t px-3 py-4">
                    {{ activity.causer_id }}
                </td> -->
                <td class="border-t px-3 py-4">
                    <!-- <inertia-link class="py-4 flex items-center focus:text-teal-800 truncate" :href="route('admin.activitylog.show', activity.id)"> -->
                    <!-- {{ activity.properties }} -->
                    <!-- </inertia-link> -->
                    <span v-for="(property, index) in activity.properties">{{ index }}: {{ property }}<br /></span>
                </td>
            </tr>
        </table>

        <pagination :links="activities.links" />
    </div>
</template>

<script>
import _ from "lodash";
import Layout from "@/admin/Shared/Layout";
import SortIcon from "@/admin/Shared/SortIcon";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Pagination from "@/admin/Shared/Pagination";
import { Inertia } from "@inertiajs/inertia";
import SearchFilter from "@/admin/Shared/SearchFilter";
import ToggleActiveIcon from "@/admin/Shared/ToggleActiveIcon";
import ActiveFilters from "@/admin/Shared/ActiveFilters";
import NumResults from "@/admin/Shared/NumResults";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import LinkButton from "@/admin/Shared/LinkButton";

export default {
    metaInfo: { title: "ActivityLog" },

    layout: Layout,

    mixins: [Helpers],

    components: {
        Pagination,
        SearchFilter,
        ActiveFilters,
        SortIcon,
        ActiveToggle: ToggleActiveIcon,
        NumResults,
        Breadcrumbs,
        LinkButton
    },

    props: {
        activities: Object,
        paginationInfo: Object,
        filters: Object,
        categories: Object
    },
    data() {
        return {
            form: {
                trashed: this.filters.trashed,
                category: this.filters.category,
                search: this.filters.search,
                orderBy: this.filters.orderBy,
                sortOrder: this.filters.sortOrder
            }
        };
    },
    methods: {
        reloadData() {
            let queryParams = _.pickBy(this.form);
            this.$inertia.replace(this.route("admin.activities.index", Object.keys(queryParams).length ? queryParams : { remember: "forget" }));
        },

        sort(col) {
            this.form.sortOrder = this.getNewSortOrder(col, this.form.orderBy, this.form.sortOrder);
            this.form.orderBy = col;
            this.reloadData();
        },

        submitSearch: _.debounce(function() {
            this.reloadData();
        }, 250),

        reset() {
            this.form = _.mapValues(this.form, () => null);
            this.reloadData();
        },

        removeFilter(filterName) {
            this.form[filterName] = null;
            this.reloadData();
        }
    }
};
</script>
